import { render, staticRenderFns } from "./table-0.vue?vue&type=template&id=742b605a&scoped=true"
import script from "./table-0.vue?vue&type=script&lang=js"
export * from "./table-0.vue?vue&type=script&lang=js"
import style0 from "./table-0.vue?vue&type=style&index=0&id=742b605a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b605a",
  null
  
)

export default component.exports